import { render } from "./Modal.vue?vue&type=template&id=4ff2b64e"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
script.render = render

export default script